export class LoadingModel {
  loadingEvents: any;
  isLoading: any;
  debug: any;

  constructor() {
    this.loadingEvents = [];
    this.isLoading = false;
    this.debug = false;
  }

  resetAll() {
    this.loadingEvents = [];
    this.isLoading = false;
  }

  setLoading(event: any, loading: any) {
    if (loading) this.loadingEvents.push(event);
    else this.loadingEvents = this.loadingEvents.filter((e: any) => e !== event);
    if (this.debug)
      console.log(
        (loading ? "Start" : "Stop") +
          " loading " +
          event +
          ". Waiting on " +
          this.loadingEvents.length +
          " events"
      );
    this.isLoading = this.loadingEvents.length > 0;
  }
}
